import React from 'react';
import { mockData } from '../utils/mockData';

const QuotePreview = ({ quoteNumber, clientInfo, items, totalHT, glueQuantity = 0, cableQuantity = 0, deliveryAddress = '', billingAddress = '' }) => {
  const today = new Date().toLocaleDateString('fr-FR', {
    day: '2-digit',
    month: '2-digit', 
    year: 'numeric'
  });

  // Plus besoin de vérifier les schémas

  // Color mapping for display
  const getColorHex = (colorName) => {
    const colorMap = {
      'Rouge': '#dc2626',
      'Bleu': '#2563eb',
      'Vert': '#16a34a', 
      'Noir': '#111827',
      'Blanc': '#ffffff',
      'Jaune': '#ca8a04',
      'Gris': '#475569',
      'Orange': '#ea580c',
      'Violet': '#7c3aed'
    };
    return colorMap[colorName] || '#94a3b8';
  };

  const generateQuoteContent = () => {
    const cablePrice = cableQuantity * 0.18;
    const gluePrice = glueQuantity * 11;
    const baseTransportPrice = 14.90;
    
    // Remise transport 70% pour AAI + Aix-en-Provence
    const isAAIAix = clientInfo.company === 'AAI' && 
                     clientInfo.agency && 
                     clientInfo.agency.toLowerCase().includes('aix');
    const transportDiscount = isAAIAix ? 0.70 : 0;
    const transportPrice = baseTransportPrice * (1 - transportDiscount);
    
    const subtotalArticles = totalHT - cablePrice - gluePrice; // Articles seulement
    const subtotalHT = totalHT + transportPrice; // Articles + câbles + colle + transport

    return `
DEVIS N° ${quoteNumber}
Date: ${today}

=== ToK'anD ===
Systèmes de gravure professionnels
60, rue François 1er
75008 Paris, FRANCE
SIRET 794 627 596 00024
Email: tok.and@outlook.fr
Téléphone: 06 09 10 49 87

=== INFORMATIONS CLIENT ===
Nom: ${clientInfo.firstName ? clientInfo.firstName + ' ' : ''}${clientInfo.name || '—'}
Société: ${clientInfo.company || '—'}${clientInfo.agency ? `\nAgence: ${clientInfo.agency}` : ''}
Email: ${clientInfo.email || '—'}
Téléphone: ${clientInfo.phone || '—'}
${clientInfo.chantier ? `Chantier: ${clientInfo.chantier}` : ''}

${deliveryAddress ? `=== ADRESSE DE LIVRAISON ===\n${deliveryAddress}\n\n` : ''}${billingAddress ? `=== ADRESSE DE FACTURATION ===\n${billingAddress}\n\n` : ''}=== DÉTAIL DES ARTICLES ===
${items.filter(item => (item.type === 'jeton' || !item.type) && (item.forme || item.couleur || item.dimension || item.gravure)).map((item, index) => {
  const details = [item.forme, item.couleur, item.dimension].filter(Boolean).join(' • ');
  const gravureText = item.gravure ? `Gravure: ${item.gravure}` : 'Pas de gravure';
  const gravureCount = item.gravure ? item.gravure.split(',').map(g => g.trim()).filter(g => g.length > 0).length : 1;
  const unitPrice = mockData.dimensionsWithPrices[item.dimension] || 0;
  
  return `${index + 1}. ${details || 'Article non défini'}
   Couleur: ${item.couleur || 'Non spécifiée'}
   ${gravureText}
   Quantité: ${gravureCount} pièce${gravureCount > 1 ? 's' : ''}
   Prix unitaire: ${unitPrice.toFixed(2)} €
   Sous-total: ${item.price.toFixed(2)} €`;
}).join('\n\n')}

=== RÉCAPITULATIF ===
Sous-total articles HT: ${subtotalArticles.toFixed(2)} €
${cableQuantity > 0 ? `Câble 220mm pour jeton (${cableQuantity}x): ${cablePrice.toFixed(2)} €\n` : ''}${glueQuantity > 0 ? `Tube colle tout matériaux 142g (${glueQuantity}x): ${gluePrice.toFixed(2)} €\n` : ''}${isAAIAix ? `Transport Colissimo (remise AAI Aix 70%): ${transportPrice.toFixed(2)} € (au lieu de ${baseTransportPrice.toFixed(2)} €)` : `Transport Colissimo (France métropolitaine): ${transportPrice.toFixed(2)} €`}
TOTAL: ${subtotalHT.toFixed(2)} €
TVA non applicable, article 293B du CGI

${clientInfo.notes ? `\n=== COMMENTAIRES CLIENT ===\n${clientInfo.notes}` : ''}

=== CONDITIONS ===
- Devis valable 45 jours à compter de la date d'émission
- TVA non applicable, article 293B du CGI
- Paiement: Net à 45 jours
- Délai de fabrication: 1 à 3 jours ouvrés
- Capacité maximum de gravure: 300x500 mm
- Transport: Colissimo 14,90€ (France métropolitaine)

---
ToK'anD - Systèmes de gravure professionnels
Ce devis a été généré le ${today}
Pour toute question: tok.and@outlook.fr
    `;
  };

  const generateHtmlContent = () => {
    const cablePrice = cableQuantity * 0.18;
    const gluePrice = glueQuantity * 11;
    const baseTransportPrice = 14.90;
    
    // Remise transport 70% pour AAI + Aix-en-Provence
    const isAAIAix = clientInfo.company === 'AAI' && 
                     clientInfo.agency && 
                     clientInfo.agency.toLowerCase().includes('aix');
    const transportDiscount = isAAIAix ? 0.70 : 0;
    const transportPrice = baseTransportPrice * (1 - transportDiscount);
    
    const subtotalArticles = totalHT - cablePrice - gluePrice; // Articles seulement
    const subtotalHT = totalHT + transportPrice; // Articles + câbles + colle + transport

    return `
<!DOCTYPE html>
<html>
<head>
    <meta charset="UTF-8">
    <style>
        body { 
            font-family: Arial, sans-serif; 
            line-height: 1.3; 
            margin: 10px; 
            font-size: 11px;
        }
        * {
            -webkit-print-color-adjust: exact !important;
            print-color-adjust: exact !important;
            color-adjust: exact !important;
        }
        .header { 
            background: linear-gradient(135deg, #059669, #0891b2); 
            color: white; 
            padding: 12px 15px; 
            border-radius: 6px; 
            margin-bottom: 10px;
            display: flex;
            justify-content: space-between;
            align-items: center;
        }
        .company-info { display: flex; align-items: center; gap: 10px; }
        .logo { 
            width: 50px; 
            height: 50px; 
            display: flex; 
            align-items: center; 
            justify-content: center; 
        }
        .logo img {
            max-width: 100%;
            max-height: 100%;
            object-fit: contain;
        }
        h1 { margin: 0; font-size: 18px; }
        h3 { margin: 0 0 5px 0; font-size: 13px; color: #059669; }
        p { margin: 5px 0; }
        
        .two-columns {
            display: grid;
            grid-template-columns: 1fr 1fr;
            gap: 10px;
            margin-bottom: 10px;
        }
        
        .info-box { 
            padding: 8px 10px; 
            border-left: 3px solid #059669; 
            background: #f8f9fa;
            font-size: 10px;
        }
        
        .compact-section {
            margin: 8px 0;
            padding: 8px 10px;
            border-left: 3px solid #059669;
            background: #f8f9fa;
            font-size: 10px;
        }
        
        .items-table { 
            width: 100%; 
            border-collapse: collapse; 
            margin: 8px 0;
            font-size: 10px;
        }
        .items-table th, .items-table td { 
            border: 1px solid #ddd; 
            padding: 5px 8px; 
            text-align: left; 
        }
        .items-table th { 
            background: #059669; 
            color: white;
            font-size: 10px;
            font-weight: 600;
        }
        
        .total-section { 
            background: #e7f3ff; 
            padding: 8px 10px; 
            border-radius: 4px;
            margin-top: 8px;
        }
        .total-row { 
            display: flex; 
            justify-content: space-between; 
            margin: 3px 0;
            font-size: 10px;
        }
        .total-final { 
            font-weight: bold; 
            font-size: 13px; 
            color: #059669;
            padding-top: 5px;
            border-top: 2px solid #059669;
            margin-top: 5px;
        }
        
        .conditions {
            margin-top: 10px;
            padding: 8px 10px;
            background: #f8f9fa;
            border-left: 3px solid #0891b2;
            font-size: 9px;
        }
        .conditions ul {
            margin: 5px 0;
            padding-left: 15px;
        }
        .conditions li {
            margin: 2px 0;
        }
        
        footer {
            text-align: center;
            margin-top: 10px;
            color: #666;
            font-size: 9px;
            padding: 8px;
            background: #f0f9ff;
            border-radius: 4px;
        }
        
        /* Action buttons container */
        .action-buttons {
            position: fixed;
            top: 70px;
            right: 20px;
            display: flex;
            gap: 10px;
            z-index: 1000;
        }
        
        /* Icon button styles - Icônes blanches sur fond vert */
        .icon-button { 
            background: #059669;
            color: white;
            border: none;
            width: 48px;
            height: 48px;
            border-radius: 50%;
            cursor: pointer;
            box-shadow: 0 4px 12px rgba(5, 150, 105, 0.4);
            display: flex;
            align-items: center;
            justify-content: center;
            transition: all 0.3s ease;
        }
        .icon-button:hover { 
            background: #047857;
            transform: scale(1.1);
            box-shadow: 0 6px 16px rgba(5, 150, 105, 0.5);
        }
        
        .icon-button svg {
            width: 24px;
            height: 24px;
            fill: white;
        }
            filter: none;
        }
        
        /* Hide action buttons when actually printing */
        @media print {
            .action-buttons { display: none !important; }
            body { margin: 5mm; }
            .header { break-inside: avoid; }
            .info-box { break-inside: avoid; }
            .compact-section { break-inside: avoid; }
            .items-table { break-inside: avoid; }
        }
    </style>
</head>
<body>
    <!-- Boutons d'action - Icônes uniquement -->
    <div class="action-buttons">
        <button class="icon-button" onclick="printQuote()" title="Imprimer le devis">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <polyline points="6 9 6 2 18 2 18 9"></polyline>
                <path d="M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2"></path>
                <rect x="6" y="14" width="12" height="8"></rect>
            </svg>
        </button>
        <button class="icon-button" onclick="saveToPDF()" title="Enregistrer en PDF">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z"></path>
                <polyline points="17 21 17 13 7 13 7 21"></polyline>
                <polyline points="7 3 7 8 15 8"></polyline>
            </svg>
        </button>
    </div>
    
    <!-- En-tête compact avec tout sur une ligne -->
    <div class="header">
        <div class="company-info">
            <div class="logo">
                <img src="https://customer-assets.emergentagent.com/job_token-quote/artifacts/tvlrvxja_3d66b585-3920-4edf-bde0-e8a74aacc0a7.jpg" alt="ToK'anD Logo" />
            </div>
            <div>
                <h1>ToK'anD - Systèmes de gravure</h1>
                <div style="font-size: 10px; margin-top: 2px;">60, rue François 1er, 75008 Paris | 📧 tok.and@outlook.fr | ☎ 06 09 10 49 87</div>
            </div>
        </div>
        <div style="text-align: right;">
            <strong style="font-size: 14px;">DEVIS N° ${quoteNumber}</strong><br>
            <span style="font-size: 10px;">${today}</span>
        </div>
    </div>

    <!-- Informations en colonnes -->
    <div class="two-columns">
        <div class="info-box">
            <h3>📋 Informations client</h3>
            <strong>${clientInfo.firstName ? clientInfo.firstName + ' ' : ''}${clientInfo.name || '—'}</strong><br>
            ${clientInfo.company || '—'}${clientInfo.agency ? ` - ${clientInfo.agency}` : ''}<br>
            📧 ${clientInfo.email || '—'}${clientInfo.phone ? ` | ☎ ${clientInfo.phone}` : ''}
            ${clientInfo.chantier ? `<br>🏗️ Chantier: ${clientInfo.chantier}` : ''}
        </div>
        
        <div class="info-box">
            <h3>🏢 Société ToK'anD</h3>
            <strong>ToK'anD - Systèmes de gravure professionnels</strong><br>
            60, rue François 1er<br>
            75008 Paris, FRANCE<br>
            <strong>SIRET 794 627 596 00024</strong><br>
            📧 tok.and@outlook.fr<br>
            ☎ 06 09 10 49 87
        </div>
    </div>

    ${deliveryAddress || billingAddress ? `
    <div class="two-columns">
        ${deliveryAddress ? `
        <div class="info-box">
            <h3>📦 Adresse de livraison</h3>
            ${deliveryAddress.replace(/\n/g, '<br>')}
        </div>
        ` : '<div></div>'}
        
        ${billingAddress ? `
        <div class="info-box">
            <h3>💳 Adresse de facturation</h3>
            ${billingAddress.replace(/\n/g, '<br>')}
        </div>
        ` : '<div></div>'}
    </div>
    ` : ''}

    <!-- Détail des articles compact -->
    <div class="compact-section">
        <h3>📦 Détail des articles</h3>
        <table class="items-table">
            <thead>
                <tr>
                    <th style="width: 3%">#</th>
                    <th style="width: 20%">Article</th>
                    <th style="width: 8%">Couleur</th>
                    <th style="width: 40%">Gravure</th>
                    <th style="width: 5%">Qté</th>
                    <th style="width: 8%">P.U.</th>
                    <th style="width: 10%">Total HT</th>
                </tr>
            </thead>
            <tbody>
                ${items.filter(item => (item.type === 'jeton' || !item.type) && (item.forme || item.couleur || item.dimension || item.gravure)).map((item, index) => {
                  const details = [item.forme, item.dimension].filter(Boolean).join(' ');
                  const gravureCount = item.gravure ? item.gravure.split(',').map(g => g.trim()).filter(g => g.length > 0).length : 1;
                  const unitPrice = mockData.dimensionsWithPrices[item.dimension] || 0;
                  
                  return `
                    <tr>
                        <td style="text-align: center;">${index + 1}</td>
                        <td><strong>${details || 'Article'}</strong></td>
                        <td style="text-align: center;"><span style="display: inline-block; width: 10px; height: 10px; border-radius: 50%; background-color: ${getColorHex(item.couleur)}; border: 1px solid #999;"></span> ${item.couleur || '—'}</td>
                        <td style="font-size: 9px;">${item.gravure || 'Sans gravure'}</td>
                        <td style="text-align: center;">${gravureCount}</td>
                        <td style="text-align: right;">${unitPrice.toFixed(2)}€</td>
                        <td style="text-align: right;"><strong>${item.price.toFixed(2)}€</strong></td>
                    </tr>
                  `;
                }).join('')}
                ${cableQuantity > 0 ? `
                <tr style="background-color: #fef3c7;">
                    <td style="text-align: center;">+</td>
                    <td colspan="3"><strong>Câble 220mm pour jeton</strong> <small>(Rond 40mm / Carré 40x40mm)</small></td>
                    <td style="text-align: center;">${cableQuantity}</td>
                    <td style="text-align: right;">0.18€</td>
                    <td style="text-align: right;"><strong>${cablePrice.toFixed(2)}€</strong></td>
                </tr>
                ` : ''}
                ${glueQuantity > 0 ? `
                <tr style="background-color: #fef3c7;">
                    <td style="text-align: center;">+</td>
                    <td colspan="3"><strong>Tube colle tout matériaux 142g</strong> <small>(Colle tout matériaux)</small></td>
                    <td style="text-align: center;">${glueQuantity}</td>
                    <td style="text-align: right;">11€</td>
                    <td style="text-align: right;"><strong>${gluePrice.toFixed(2)}€</strong></td>
                </tr>
                ` : ''}
                <tr style="background-color: #e0f2fe;">
                    <td style="text-align: center;">+</td>
                    <td colspan="3"><strong>Transport Colissimo</strong> <small>(France métropolitaine)</small></td>
                    <td style="text-align: center;">1</td>
                    <td style="text-align: right;">14.90€</td>
                    <td style="text-align: right;"><strong>${transportPrice.toFixed(2)}€</strong></td>
                </tr>
            </tbody>
        </table>
    </div>

    <!-- Récapitulatif compact -->
    <div class="total-section">
        <div class="total-row">
            <span>Sous-total articles HT:</span>
            <span><strong>${subtotalArticles.toFixed(2)} €</strong></span>
        </div>
        ${cableQuantity > 0 ? `
        <div class="total-row">
            <span>Câble 220mm pour jeton (${cableQuantity}x):</span>
            <span>${cablePrice.toFixed(2)} €</span>
        </div>
        ` : ''}
        ${glueQuantity > 0 ? `
        <div class="total-row">
            <span>Colle tout matériaux (${glueQuantity}x):</span>
            <span>${gluePrice.toFixed(2)} €</span>
        </div>
        ` : ''}
        <div class="total-row">
            <span>Transport${isAAIAix ? ' <small style="color: #16a34a;">(remise AAI Aix 70%)</small>' : ''}:</span>
            <span>${isAAIAix ? `<span style="text-decoration: line-through; color: #999; margin-right: 5px;">${baseTransportPrice.toFixed(2)} €</span>` : ''}${transportPrice.toFixed(2)} €</span>
        </div>
        <div class="total-row total-final">
            <span>TOTAL:</span>
            <span>${subtotalHT.toFixed(2)} €</span>
        </div>
        <div class="total-row" style="font-size: 9px; color: #666; font-style: italic;">
            <span colspan="2">TVA non applicable, article 293B du CGI</span>
        </div>
    </div>

    ${clientInfo.notes ? `
    <div class="compact-section" style="background: #fffbeb; border-left-color: #f59e0b;">
        <h3>💬 Commentaires</h3>
        <p style="margin: 3px 0;">${clientInfo.notes}</p>
    </div>
    ` : ''}

    <!-- Conditions et informations de paiement -->
    <div class="conditions">
        <strong style="font-size: 10px;">📋 Conditions générales:</strong>
        <ul>
            <li><strong>Validité:</strong> 45 jours | <strong>Paiement:</strong> Net à 45 jours</li>
            <li><strong>TVA non applicable</strong>, article 293B du CGI</li>
            <li><strong>Délai de fabrication:</strong> 1 à 3 jours ouvrés | <strong>Capacité gravure max:</strong> 300x500 mm</li>
            <li><strong>Transport:</strong> Colissimo 14,90€ (France métropolitaine)</li>
        </ul>
    </div>

    <!-- Informations pour passer commande -->
    <div class="compact-section" style="background: #f0f9ff; border-left-color: #0891b2;">
        <h3>📞 Pour passer commande</h3>
        <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 10px; font-size: 10px;">
            <div>
                <strong>Contact:</strong><br>
                ☎ 06 09 10 49 87<br>
                📧 tok.and@outlook.fr
            </div>
            <div>
                <strong>Adresse:</strong><br>
                ToK'anD<br>
                60, rue François 1er<br>
                75008 Paris, FRANCE
            </div>
        </div>
    </div>

    <footer>
        <strong>ToK'anD - SIRET 794 627 596 00024</strong><br>
        TVA non applicable, article 293B du CGI<br>
        Devis généré le ${today}
    </footer>

    <script src="https://cdnjs.cloudflare.com/ajax/libs/html2pdf.js/0.10.1/html2pdf.bundle.min.js"></script>
    <script src="https://cdnjs.cloudflare.com/ajax/libs/jspdf/2.5.1/jspdf.umd.min.js"></script>
    <script src="https://cdnjs.cloudflare.com/ajax/libs/html2canvas/1.4.1/html2canvas.min.js"></script>
    <style>
        /* Styles spécifiques pour le PDF et l'impression */
        @media print {
            * {
                -webkit-print-color-adjust: exact !important;
                print-color-adjust: exact !important;
                color-adjust: exact !important;
            }
            /* Masquer les boutons d'action à l'impression */
            .action-buttons {
                display: none !important;
            }
        }
    </style>
    <script>
        // Fonction pour améliorer l'impression
        function printQuote() {
            window.print();
        }
        
        // Fonction pour enregistrer en PDF - VERSION ROBUSTE
        function saveToPDF() {
            // Cacher les boutons pendant la génération du PDF
            const buttons = document.querySelector('.action-buttons');
            if (buttons) {
                buttons.style.display = 'none';
            }
            
            // Vérifier si html2pdf est chargé
            if (typeof html2pdf === 'undefined') {
                console.error('html2pdf not loaded, using fallback');
                if (buttons) buttons.style.display = 'flex';
                alert('⚠️ Impossible de générer le PDF automatiquement.\\n\\nVeuillez utiliser le bouton "Imprimer" puis sélectionner "Enregistrer en PDF" dans la boîte de dialogue.');
                return;
            }
            
            try {
                // Configuration optimisée
                const opt = {
                    margin: [5, 8, 5, 8],
                    filename: 'Devis_${quoteNumber}_${today.replace(/\//g, '-')}.pdf',
                    image: { 
                        type: 'jpeg', 
                        quality: 0.95 
                    },
                    html2canvas: { 
                        scale: 2,
                        useCORS: true,
                        logging: false,
                        letterRendering: true,
                        allowTaint: true,
                        backgroundColor: '#ffffff'
                    },
                    jsPDF: { 
                        unit: 'mm', 
                        format: 'a4', 
                        orientation: 'portrait',
                        compress: true
                    }
                };
                
                // Cloner le body
                const element = document.body.cloneNode(true);
                const cloneButtons = element.querySelector('.action-buttons');
                if (cloneButtons) {
                    cloneButtons.remove();
                }
                
                // Générer le PDF
                html2pdf().set(opt).from(element).save()
                    .then(() => {
                        if (buttons) buttons.style.display = 'flex';
                        console.log('PDF généré avec succès');
                    })
                    .catch((error) => {
                        console.error('Erreur html2pdf:', error);
                        if (buttons) buttons.style.display = 'flex';
                        alert('⚠️ Erreur lors de la génération du PDF.\\n\\nVeuillez utiliser le bouton "Imprimer" puis sélectionner "Enregistrer en PDF".');
                    });
                    
            } catch (error) {
                console.error('Erreur catch:', error);
                if (buttons) buttons.style.display = 'flex';
                alert('⚠️ Erreur lors de la génération du PDF.\\n\\nVeuillez utiliser le bouton "Imprimer" puis sélectionner "Enregistrer en PDF".');
            }
        }
        
        // Attendre que la page soit complètement chargée
        window.addEventListener('load', function() {
            console.log('Page chargée, html2pdf disponible:', typeof html2pdf !== 'undefined');
        });
        
        // Ajouter un raccourci clavier Ctrl+P
        document.addEventListener('keydown', function(e) {
            if (e.ctrlKey && e.key === 'p') {
                e.preventDefault();
                printQuote();
            }
        });
        
        // Message après impression
        window.addEventListener('afterprint', function() {
            console.log('Devis imprimé avec succès');
        });
    </script>
</body>
</html>
    `;
  };

  return {
    textContent: generateQuoteContent(),
    htmlContent: generateHtmlContent()
  };
};

export default QuotePreview;